/** Created by azhou on 2019/3/1.*/
<template>
  <div class="mt-4">
    <!--定向订单信息-->
    <div v-if="appointHotel" class="mb-3">
      <div class="d-center-start">
        <left-text leftText="预订酒店" :width="60"/>
        <span class="bg-login text-white p-2 rounded">{{DisplayBasicInfo.title}}</span>
        <!-- <span class="text-info ml-3">{{DisplayBasicInfo.star | formatVar('HotelStar')}}</span>
        <span class="text-muted ml-3">（{{DisplayBasicInfo.province_name + DisplayBasicInfo.city_name + DisplayBasicInfo.district_name}}）</span> -->
      </div>
    </div>
    <div class="d-center-start mb-3">
      <left-text leftText="团队类型" :width="60"/>
        <div class="d-center-start el-selectq">
            <el-select v-model="postInfo.team_type" slot="prepend" placeholder="请选择" :disabled="true">
            <!-- <el-option label="旅游团" value="1"></el-option> -->
            <el-option label="会议团" value="2"></el-option>
          </el-select>
          <el-input :disabled="true" v-model="postInfo.title" :restaurants="teamsto"></el-input>
        </div>
    </div>
    <!--客房需求相关-->
    <div class="d-start-start mb-3">
       <left-text leftText="会议需求" :width="60"/>
       <div class="meeting">
        <span   class="w-1p mr-1" v-for="(item,index) in meetingname" :key="index">{{item}}</span>
        <span   class="w-2p mr-2">出席人数</span>
        <span   class="w-2p mr-2">要求面积</span>
        <span   class="w-3p mr-1" v-if="!modify">名称</span>
        <span   class="w-1p mr-1" v-if="!modify">价格</span>
       </div>
    </div>
    <div 
      class=" el-checkbox-group d-center-start flex-wrap p-2 nsl"
      v-for="(item,index) in meetObj" :key="index">
      <el-date-picker v-model="item.date"
                      type="date" 
                      class="w-1p mr-1"
                      :class="{'Borderred': item.date==''}"
                      value-format="timestamp"
                      :picker-options="startDateLimit"
                      :disabled="true"
                      placeholder="选择日期"/>
      <el-select :disabled="true" v-model="item.timeslot" class="w-1p mr-1" :class="{'Borderred': item.timeslot==''}">
        <el-option v-for="item in $GVAR.TimeSlots"
                   :key="item.name"
                   :label="item.name"
                   :value="item.id"/>
      </el-select>
      <el-select :disabled="true" v-model="item.type" class="w-1p mr-1" :class="{'Borderred': item.type==''}">
        <el-option v-for="item in $GVAR.LayoutTypes"
                   :key="item.name"
                   :label="item.name"
                   :value="item.id"/>
      </el-select>
      <el-input type="number" :disabled="true" v-model.number="item.num" @mousewheel.native.prevent class="w-2p mr-1" placeholder="0" :class="{'Borderred': item.num==''&&item.num==0}">
          <span slot="append">人</span>
      </el-input>
      <el-input type="number"  :disabled="true" v-model.number="item.area" @mousewheel.native.prevent class="w-2p mr-1" placeholder="0" :class="{'Borderred': item.area==''&&item.area==0}">
          <span slot="append">㎡</span>
        </el-input>
        <el-select class="w-10 mr-3 mr-49 pl-2" 
                  v-model="item.id"
                  @change="getId($event,index)"
                  filterable
                  allow-create
                  :disabled="true"
                  default-first-option
                  @blur="blurs($event,index)"
                  :placeholder="item.offer_title||'请选择或输入房型'"
                  :class="{'Borderred': item.offer_title==''}"
                  v-if="!modify"
                  >
          <el-option 
                    v-for="roomItem in StoreMeetArr"
                    :key="roomItem.title"
                    :label="roomItem.title"
                    :value="`${roomItem.id},${roomItem.title}`">
          </el-option>
      </el-select>
      <el-input placeholder="金额" class="w-28 mr-2 price" type="number" v-if="!modify" :class="{'Borderred': item.offer_price==''&&item.offer_price==0}"
                v-model.number="item.offer_price">
        <span slot="prepend">&yen;</span>
        <span slot="append" class="lisxn">元</span>
      </el-input>
    </div>  
    <!--修改订单附加需求相关-->
    <div  v-if="!modify">
      <div class="d-start-start mb-3">
        <left-text leftText="附加需求" :width="60"/>
        <div class="meeting" v-if="add_need.length>0">
          <span   class="w-3p mr-1">名称</span>
          <span   class="w-1p mr-1">金额</span>
        </div>
        <div  v-if="add_need.length<=0">
            无
        </div>  
      </div>
        <div class=" el-checkbox-group d-center-start flex-wrap p-2 nsl"  v-for="(item,index) in add_need" :key="index">
            <el-select class="w-3p mr-1 mr-49" 
                    v-model="item.id"
                    @change="getId($event,index,3)"
                    @blur="blurs($event,index,3)"
                    filterable
                    allow-create
                    default-first-option
                    :placeholder="item.add_title||'请选择或输入名称'"
                    v-if="!modify"
              >
                <el-option 
                    v-for="roomItem in add_name"
                    :key="roomItem.title"
                    :label="roomItem.title"
                    :value="`${roomItem.id},${roomItem.title}`">
                </el-option>
            </el-select>
            <el-input placeholder="金额" class="w-28 mr-1 price" type="number"
                      v-model.number="item.add_price">
              <span slot="prepend">&yen;</span>
              <span slot="append" class="lisxn">元</span>
            </el-input>
            <div class="closes" >
              <i class="el-icon-circle-close" @click="splicse(index,3)"></i>
            </div>
      </div>
    </div>
    <!--订单修改-->
    <div class="d-center-start mb-3 form-width"  v-if="!modify">
      <left-text leftText="订金" :width="60" />
      <el-input :disabled="true" type="number" @mousewheel.native.prevent style="width: 140px;" v-model.number="postInfo.deposit"><span slot="append">元</span></el-input>
    </div>
    <!--会议室需求-->
    <div class="d-center-start mb-3">
      <left-text leftText="其他需求" :width="60"/>
      <el-checkbox   :disabled="true" v-model="item.meets" v-for="(item,index) in meetRoomObj" :key="index">{{item.name}}</el-checkbox>
    </div>
    <left-text-border class="mb-3 form-width"
                      leftText="报价说明"
                      :width="60"
                      :disabled="true"
                      placeholder="可输入订单需求备注"
                      type="textarea"
                      v-model="postInfo.remark"/>
    <div class="d-center-start mb-3" v-if="modify">
      <left-text leftText="联系人" :width="60"/>
      <label class="text-muted">
        {{orderPostPre.truename}}（{{orderPostPre.mobile}}）
        <!-- — {{orderPostPre.contact.title}}（{{orderPostPre.contact.telephone || '空'}}） -->
      </label>
    </div>  
    <el-button class="mt-4" type="success" @click="goBack" v-if="!modify">返回</el-button>
    <div class=" mt-4 hs  ml-3"  @click="validateForm(0)" v-if="!modify&&invoicing_change==1">设置代订收款</div>
    <el-dialog title="确认订单" :visible.sync="showConfirmPanel" width="50%" center id="loadConfirm">
      <confirm-panel :postInfo="postInfo" :cityName="cityName" :meetingArrs='meetObj'/>
      <div slot="footer">
        <el-button size="small" @click="showConfirmPanel = false">返回修改</el-button>
        <el-button size="small" type="primary" @click="submitPost">确认发布</el-button>
      </div>
    </el-dialog>
    <div class="botext">设置代订收款后，不会影响原订单内容，只作为对外展示内容</div>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import ConfirmPanel from '../ConfirmPanel'
  export default {
    name: 'PostRoomOrder',
    components: { ConfirmPanel },
    computed: {
      ...mapState(['OrderDetail','orderPostPre','DisplayBasicInfo','StoreLists','StoreMeetArr']),
      ...mapGetters(['storeInfo','isGroup']),
      //入住日期开始时间戳
      startDateLimit () {
        let modify=this.modify;
        return {
          disabledDate (time) {
          let n=modify?time.getTime() < Date.now() - 8.64e7:'';
            return n;
          },
        }
      },
      //共入住间夜数
      totalNum () { return (this.postInfo.date_out - this.postInfo.date_in) / 86400 },
      //用房需求总数
      totalRoom () {
        let total = 0
        this.priceArr.forEach(v => total += Number(this.postInfo[v.value]))
        return total;
      },
      //订单类型
      orderType () {
        if (this.totalNum > 0 && this.needMeets) {
          return '3'
        } else if (this.totalNum) {
          return '3'//1
        } else if (this.needMeets) return '2'
        return ''
      },
      //路由中的酒店ID，存在时判断为定向订单
      appointHotel() { return this.$route.query.hotel },
      //是否设置支付人
      pay_arr() { return this.$route.query.pay_arr},
      //是否是代订收款修改
      invoicing_change() { return this.$route.query.invoicing_change||0},
    },
    data () {
      return {
         pickerOptions: {
          onPick: ({ maxDate, minDate }) => {
            console.log(maxDate,minDate)
            if (minDate && !maxDate) {
              this.timeOptionRange = minDate
            }
            if (maxDate) {
              this.timeOptionRange = null
            }
          },
          disabledDate: (time) => {
            // 获取选中时间
            let timeOptionRange = this.timeOptionRange
            let dayRange = 1 * 24 * 60  * 1000;
            if (timeOptionRange) {
              return time.getTime() < Date.now() - 8.64e7 || time.getTime() === timeOptionRange.getTime() || time.getTime() === timeOptionRange.getTime() + dayRange || time.getTime() === timeOptionRange.getTime() - dayRange
            }else{
              return time.getTime() < Date.now() - 8.64e7
            }
          }
        },
        modify:true,
        postInfo: {
          order_type:2,
          team_type:'2',
          title: '',
          province: '',
          city: '',
          county: [],
          star: [],
          date_in: '',
          date_out: '',
          breakfast:-1,
          // queen_room: '',
          // standard_room: '',
          // triple_room: '',
          // department_room: '',
          num: '',
          room_need:'',
          meeting_mess: [],
          // tea_break: false,
          // is_meal: 0,
          other:'',
          remark: '',
          district:'',
          appoint_store_id:'',
          add_need:[],
        },
        dialogVisible: false,
        search: '',
        current: -1,
        total: 0,
        page: 1,
        chooseTravel: {},
        url: 'pc/Travel/getStoreMaterial',
        timestamp: '',
        needMeets: false,
        meetRoomObj: [
          {name:'LED',meets:false,id:'2'},
          {name:'投影仪',meets:false,id:'3'},
          {name:'茶歇',meets:false,id:'4'},
          {name:'餐饮',meets:false,id:'5'},
          {name:'搭建',meets:false,id:'6'},
        ],
        meetObj:[{ date: '', timeslot: '', num: '',area:'', type: ''}],
        meetObjfs:[{ date: '', timeslot: '', num: '',area:'', type: ''}],
        meetObjfsTwo:[{ date: '', timeslot: '', num: '',area:'', type: '',offer_title:'',offer_price:''}],
        add_need:[],                                                                                  //添加附加需求组
        add_needs:[{add_title:'',add_price:'',}],                                                     //添加附加需求组的内容
        add_name:[{title:'会场费',id:0},{title:'餐费',id:1},{title:'其他',id:2}],
        showConfirmPanel:false,
        cityName:{},
        teamsto: [
          { "value": "年会"},
          { "value": "工作会/总结会"},
          { "value": "同学会/好友聚会"},
          { "value": "答谢会"},
          { "value": "发布会/颁奖/庆典"},
          { "value": "OUTING/会奖"},
          { "value": "培训/讲座"},
          { "value": "研讨/交流/论坛"},
          { "value": "经销商会议/招商会/推介会"},
          { "value": "团队建设/拓展/休闲会议"}, 
          { "value": "沙龙"},
        ],
        dumpling: [
          {name: '会议团',},
        ],
        lis:0,
        meetingname:[
          '开会日期','时段','布局',
        ],
        meetingnametwo:[
          '开会日期','时段','布局',
        ],
        teamcurrent: -1,
        lies:[]
      }
    },
    filters:{
      lineBreak:function(data){
        return data.replace(/<br>/g,'\n');
      }
    },
    watch: {
      //入住和离店日期戳
      timestamp (newVal) {
        this.postInfo.date_in = newVal[0] / 1000;
        this.postInfo.date_out = newVal[1] / 1000
      },
      //是否需要会议室
      needMeets (newVal) {
        if (!newVal) this.postInfo.meeting_mess = [];
      },
      //采购商重发订单和管理员编辑订单时订单的信息
      OrderDetail(newVal) {
        if (!$.isEmptyObject(newVal)) {
          this.modify=false;
          this.getMeetLists(newVal.offer_store_id)                                              //获取会议室列表
          newVal.star=newVal.star.split(',');                              //会议需求
          newVal.city=newVal.city*1,newVal.province=newVal.province*1;     //省市
          newVal.district=newVal.district.split(',');
          newVal.district_name=newVal.district_name.split(',');                      
          newVal.county=newVal.district.map(v => v*1);                     //地区
          this.postInfo={...newVal}
          this.postInfo.order_type=2;                                      //切换修改订单类型
          for(let i in newVal.meeting_need_arr){
            newVal.meeting_need_arr[i].date=newVal.meeting_need_arr[i].date*1000;
          }
          this.meetObj=newVal.meeting_need_arr                             //会议需求
          this.add_need=newVal.add_need_arr                                //附加需求
          for(let i in this.meetRoomObj){                                  //酒店星级
            let other=newVal.other;
                if(other.indexOf(this.meetRoomObj[i].id)!=-1){
                  this.meetRoomObj[i].meets=true;
                }
          }
          this.cityName = {                                               //省市区文字描述
            province_name:this.postInfo.province_name,
            city_name:this.postInfo.city_name,
            district:newVal.district.map((v,index) => {
              return {id:v,name:newVal.district_name[index]}
            })
          }
        }
      },
    },
    beforeDestroy() { this.UPDATECURRENTSTORE({ storeId: '' }) },
    methods: {
      //返回上一页面
      goBack() {
        this.$router.go(-1); 
      },
      getId(val,index,p){
        let [id, name] = val.split(','),room_offer={};
        let n=p==3?this.add_need:this.meetObj;
            if(p==3){
              room_offer={...n[index],add_title:name?name:id}
            }else{
              room_offer={...n[index],offer_id:name?id:'0',offer_title:name?name:id}
            }
            this.$set(n,index,room_offer);
          this.$set(n,index,room_offer);
      },
      blurs(val,index,p){
        let n=p==3?this.add_need:this.meetObj,room_offer={};
          console.log(n)
          if(val.target.value){
          if(p==3){
            room_offer={...n[index],id:val.target.value,add_title:val.target.value}
          }else{
            room_offer={...n[index],id:val.target.value,offer_id:'0',offer_title:val.target.value}
          }
          this.$set(n,index,room_offer)
        }
      },
      splicse(index,p){
          p==3?this.add_need.splice(index,1):this.meetObj.splice(index,1)
      },
      //添加一条会议需求
      addMeeting(){
        let data
        if(!this.modify){
          data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfsTwo[0])));
        }else{
          data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs[0])));
        }
        this.meetObj.push(data)
        //  this.$set(this.meetObj,this.meetObj.length, this.meetObjfs);
        // this.meetObj.push(this.meetObjfs)
      },
      //添加一条附加需求
      addNeed(){
        let data = Object.assign({}, JSON.parse(JSON.stringify(this.add_needs[0])));
        this.add_need.push(data)
      },
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getMeetLists','GetOrderDetail','travelPostOrderPre','travelPostOrder','adminEditOrderPre','adminEditOrder','GetDisplayInfo','TraGroupGetStoreLists','travelRecipient']),
      enSure () {
        this.UPDATECURRENTSTORE({ storeId: this.chooseTravel.store_id })
        this.dialogVisible = false
      },
      getTravelList (search) {
        if (search) this.TraGroupGetStoreLists({ url: this.url, data: {page: 1,title: this.search} })
        else this.TraGroupGetStoreLists({ url: this.url, data: {title: this.search} })
      },
      choose (item, index) {
        this.chooseTravel = {}; this.chooseTravel = item; this.current = index
      },
      //获取省市区id
      getCityInfo (info) {
        console.log(info)
        this.postInfo.province = info.province;
        this.postInfo.city = info.city;
        this.postInfo.county = info.district.map(v => v.id);
        this.cityName = info;
      },
      //验证添加会议室
      validateAddMeet () {
        if (!this.meetRoomObj.date) return { code: false, msg: '请选择会议时间' }
        if (this.meetRoomObj.num <= 0) return { code: false, msg: '请填写会议人数' }
        return { code: true, msg: '验证通过' }
      },
      
      /*添加会议室需求*/
      addMeet () {
        let res = this.validateAddMeet()
        if (res.code) {
          let obj = {
            ...this.meetRoomObj,
            date: this.meetRoomObj.date / 1000,
            led: this.meetRoomObj.led ? '2' : '1',
            projector: this.meetRoomObj.projector ? '2' : '1',
          }
          this.postInfo.meeting_mess.push(obj)
        } else this._alert(res.msg, null, 'error')
      },
      /*验证表单*/
      validateForm(flag){
        let other=[];//是否填写用房需求
        for(let i in this.meetRoomObj){
          if(this.meetRoomObj[i].meets==true){
            other.push(this.meetRoomObj[i].id)
          }
        }
        this.postInfo.other=other||'' 
        //验证表单完成性
        let meetObj=JSON.parse(JSON.stringify(this.meetObj));
        const allValuesNotEmpty = meetObj.every((obj) => {
            delete  obj.offer_id;
            return Object.values(obj).every((value) => {return value!==""&&value!==0});
        });
        //验证附件信息表单完成性
        const add_needvalue = this.add_need.every((obj) => {
              return Object.values(obj).every((value) => value !== ""&&value!==0);
        });
        let res = (() => {
          //if (this.isGroup && JSON.stringify(this.chooseTravel) == '{}') return { code: false, msg: '集团用户请选择采购商' }
          if (!this.postInfo.title)  return { code: false, msg: '请填写团号' }
          if (this.postInfo.county.length <= 0) return { code: false, msg: '请选择订单目标区域' }
          if (this.postInfo.star.length <= 0) return { code: false, msg: '请选择酒店星级' }
          if (this.meetObj.length<=0) return { code: false, msg: '请填写一条会议信息' }
          console.log(this.meetObj);
          if (!allValuesNotEmpty) return { code: false, msg: '请添写完整的会议需求信息(或人数面积为0)'}
          if (!add_needvalue&&!this.modify) return { code: false, msg: '请添写完整的附加需求(或金额为0)'}; 
          return { code: true, msg: '验证通过' }
        })();
        if (res.code) this.modify?this.showConfirmPanel = true:this.modifyPost(flag);
        else this._alert(res.msg, null, 'error');
      },
      /*修改订单*/
      modifyPost(flag){
        this._confirm('不影响原订单内容，只作为代订收款内容对外展示！',() => {
            let lies=JSON.parse(JSON.stringify(this.meetObj));
            lies.forEach((item)=>{
                item.date=item.date/1000
            })
            if(this.postInfo.length!=0){
              this.postInfo.other=this.postInfo.other.join(',')
            }
            this.postInfo.meeting_need=JSON.stringify(lies);
            if(this.add_need.length!=0){this.postInfo.add_need=JSON.stringify(this.add_need);}
            this.postInfo.district=this.postInfo.county.join(',');
            if(Array.isArray(this.postInfo.star)){
              this.postInfo.star=this.postInfo.star.join(',');
            }
            //如果是收款修改调取另一个方法
            if(this.invoicing_change==1){
              console.log(this.invoicing_change)
                this.PsotTravelRecipient(flag)
                return
            }
            //正常修改订单
            this.travelPostOrder({
              data:{
                ...this.postInfo,
                // tea_break:this.postInfo.tea_break ? '1' : '0',
                modify:this.modify,
                flag:flag
              },
              successFun:() => {
                //修改提示文字
                let tips=this.storeInfo.type==2?this.$GVAR.travelTips.tips:this.$GVAR.hotelTips.tips;     
                this.showConfirmPanel = false;
                this._alert(tips,() => {
                  if (this.appointHotel)  this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}})
                  else this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}}) 
                })
              }
            }); 
        });
      },
      //提交收款人修改
      PsotTravelRecipient(flag){
        console.log(this.postInfo);
        this.travelRecipient({
          data:{
            ...this.postInfo,
            flag:flag
          },
          successFun:() => {
            //修改提示文字
            this.showConfirmPanel = false;
            this._alert('设置待收款订单成功',() => {
              this.$router.go(-1);
              // if (this.appointHotel)  this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}})
              // else this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}}) 
            })
          }
        }); 
      },
      /*提交订单*/
      submitPost() {
        let lies=JSON.parse(JSON.stringify(this.meetObj));
        lies.forEach((item)=>{
            item.date=item.date/1000
        })
        if(this.postInfo.length!=0){
          this.postInfo.other=this.postInfo.other.join(',')
        }
        this.postInfo.meeting_need=JSON.stringify(lies);
        this.postInfo.district=this.postInfo.county.join(',');
         if(Array.isArray(this.postInfo.star)){
            this.postInfo.star=this.postInfo.star.join(',');
         }
        switch (this.storeInfo.type) {
          case 2: this.travelPostOrder({
            data:{
              ...this.postInfo,
              // tea_break:this.postInfo.tea_break ? '1' : '0',
              modify:this.modify
            },
            successFun:() => {
              this.showConfirmPanel = false;
              this._alert('订单发布成功',() => {
                if (this.appointHotel)  this.$router.push({name:'OrderLists',query:{orderStatus:'4',page:1,orderType:3}})
                else this.$router.push({name:'OrderLists',query:{orderStatus:'all',page:1,orderType:3}}) 
              })
            },
            successNone:(msg)=>{
              this.showConfirmPanel = false;
                this._alert(msg,() => {
                    this.$router.go(-1);
                })
            }
          }); break;
          case 99 :
            this.adminEditOrder({
            data:{
              ...this.postInfo,
              tea_break:this.postInfo.tea_break ? '1' : '0',
              order_type:this.orderType
            },
            successFun:() => {
              this.showConfirmPanel = false;
              this._alert('订单编辑成功',() => { this.$router.push({name:'OrderDetail',query:{orderType:3,orderId:this.postInfo.id}}) })
            }
          }); break;
        }
      }
    },
    created () {
      if(this.$route.query.type!='住宿订单'&&this.$route.query.orderId){
        this.GetOrderDetail(this.$route.query.orderId);
      }
      switch (this.storeInfo.type) {
        case 2:this.travelPostOrderPre(this.$route.query.orderId); break;
        case 99:this.adminEditOrderPre(this.$route.query.orderId); break;
      }
      //定向订单的页面赋值
      if (this.appointHotel) {
        this.GetDisplayInfo({
          type:'3',
          data:{id:this.appointHotel},
          successFun:(e) => {
            this.postInfo.appoint_store_id = this.appointHotel;
            this.postInfo.hotel_id = this.appointHotel;
            this.postInfo.province = e.province;
            this.postInfo.city = e.city;
            this.postInfo.county.push(e.district);
            this.postInfo.star.push(e.star);
            this.cityName = {
              province_name:e.province_name,
              city_name:e.city_name,
              district:[{id:e.district,name:e.district_name}]
            }
          }
        });
      }
    }
  }
  
</script>
<style scoped lang="scss">
  .meeting{
    float: left;
  }
  .el-input__inner{
    height: 40px !important;
  }
  .meeting span{
    text-align: center;
    display: inline-block;
  }
  .w-1p{
    width: 136px;
  }
  .w-2p{
    width: 90px;
  }
    .w-3p{
    width: 210px !important;  
  }
  .nsl{
    margin-left: 75px;
  }

  .form-widtht{
    width: 574px;
    text-align:center;
    .nis{
      font-size: 24px;
      color: var(--smtc-color-primary); 
      margin: 0 auto;
      cursor: pointer;
    }
  }
  .closes{
    i{
      font-size: 20px;
      color: #db2928 !important;
      cursor: pointer;
    }
  }
  .hs{
    background-color: #ff8907;
    border: 1px #ff8907 solid;
    color: #fff;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
  }
  .hs:hover{
    background-color: #fa9424;
    border: 1px #fa9424 solid;
  }
  .widerl{
    width: 850px;
  }
</style>
<style>
  .Borderred .el-input__inner{
    border: 1px solid #db2928;
  }
</style>